import { default as claim_45received_46specjxtwGwVVBWMeta } from "/app/apps/concierge/src/pages/claim-received.spec.js?macro=true";
import { default as claim_45receivedtA7zrOAMLAMeta } from "/app/apps/concierge/src/pages/claim-received.vue?macro=true";
import { default as index_46specMpnnOViGwOMeta } from "/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js?macro=true";
import { default as indexCkO8MIMQepMeta } from "/app/apps/concierge/src/pages/in-store/contact-info/index.vue?macro=true";
import { default as contact_45infoE1QbxPQPlbMeta } from "/app/apps/concierge/src/pages/in-store/contact-info.vue?macro=true";
import { default as index_46spec0AEOhpWjN5Meta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js?macro=true";
import { default as indexhdYcLed0biMeta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue?macro=true";
import { default as date_45of_45purchasedkVr3rQxkvMeta } from "/app/apps/concierge/src/pages/in-store/date-of-purchase.vue?macro=true";
import { default as index_46spectD15h05FdMMeta } from "/app/apps/concierge/src/pages/in-store/products/index.spec.js?macro=true";
import { default as indexoSamL5dG7OMeta } from "/app/apps/concierge/src/pages/in-store/products/index.vue?macro=true";
import { default as index_46spec1XcAoLicwjMeta } from "/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js?macro=true";
import { default as indexXxVIvVMOljMeta } from "/app/apps/concierge/src/pages/in-store/products/not-found/index.vue?macro=true";
import { default as productskftfBxuZWaMeta } from "/app/apps/concierge/src/pages/in-store/products.vue?macro=true";
import { default as index_46specGfhVm1segXMeta } from "/app/apps/concierge/src/pages/in-store/receipt/index.spec.js?macro=true";
import { default as indexE2JSrHICpJMeta } from "/app/apps/concierge/src/pages/in-store/receipt/index.vue?macro=true";
import { default as index_46specusI6AOw6shMeta } from "/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js?macro=true";
import { default as indexxU8B17mUGAMeta } from "/app/apps/concierge/src/pages/in-store/receipt/required/index.vue?macro=true";
import { default as index_46specsjcgTUE00LMeta } from "/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js?macro=true";
import { default as indexPiPUogZGw5Meta } from "/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue?macro=true";
import { default as receiptqXVH1zaSo3Meta } from "/app/apps/concierge/src/pages/in-store/receipt.vue?macro=true";
import { default as index7kwq96cxT3Meta } from "/app/apps/concierge/src/pages/in-store/resolution/index.vue?macro=true";
import { default as resolutionNnLUXJzuxwMeta } from "/app/apps/concierge/src/pages/in-store/resolution.vue?macro=true";
import { default as index_46spec36MaY3ZjAGMeta } from "/app/apps/concierge/src/pages/in-store/review/index.spec.js?macro=true";
import { default as indexIKepb970L5Meta } from "/app/apps/concierge/src/pages/in-store/review/index.vue?macro=true";
import { default as reviewSLW2cf9QkQMeta } from "/app/apps/concierge/src/pages/in-store/review.vue?macro=true";
import { default as index_46spec7qFFL2UkoTMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js?macro=true";
import { default as indexnIViEN2jLPMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address/index.vue?macro=true";
import { default as shipping_45addressV0NtiW5E3SMeta } from "/app/apps/concierge/src/pages/in-store/shipping-address.vue?macro=true";
import { default as uploadyn5FoRv4yoMeta } from "/app/apps/concierge/src/pages/in-store/upload.vue?macro=true";
import { default as index_46specIWek603zjSMeta } from "/app/apps/concierge/src/pages/index.spec.js?macro=true";
import { default as indexRcFS2qQuICMeta } from "/app/apps/concierge/src/pages/index.vue?macro=true";
import { default as issues_46specHVTV4dsJ3QMeta } from "/app/apps/concierge/src/pages/issues.spec.js?macro=true";
import { default as index_46specM8vyosDx74Meta } from "/app/apps/concierge/src/pages/issues/index.spec.js?macro=true";
import { default as indexmRa9T7Az1zMeta } from "/app/apps/concierge/src/pages/issues/index.vue?macro=true";
import { default as items_46speciTSJnQNVNtMeta } from "/app/apps/concierge/src/pages/issues/items.spec.js?macro=true";
import { default as itemsSebbLmbLe1Meta } from "/app/apps/concierge/src/pages/issues/items.vue?macro=true";
import { default as shipment_46specoNQRKC5NOdMeta } from "/app/apps/concierge/src/pages/issues/shipment.spec.js?macro=true";
import { default as details_46specicaZjB1zm8Meta } from "/app/apps/concierge/src/pages/issues/shipment/details.spec.js?macro=true";
import { default as detailsBKlJcXYpm2Meta } from "/app/apps/concierge/src/pages/issues/shipment/details.vue?macro=true";
import { default as index_46specQ7dha50LT7Meta } from "/app/apps/concierge/src/pages/issues/shipment/index.spec.js?macro=true";
import { default as index7x3su0Y6wWMeta } from "/app/apps/concierge/src/pages/issues/shipment/index.vue?macro=true";
import { default as shipmentIdbapodMXWMeta } from "/app/apps/concierge/src/pages/issues/shipment.vue?macro=true";
import { default as issuesePjfeQqLO9Meta } from "/app/apps/concierge/src/pages/issues.vue?macro=true";
import { default as index_46specRRjZ1lib2YMeta } from "/app/apps/concierge/src/pages/multiple-shipments/index.spec.js?macro=true";
import { default as indexa09j5lhPCzMeta } from "/app/apps/concierge/src/pages/multiple-shipments/index.vue?macro=true";
import { default as not_45shipped_46spec3ZzDbT0zKyMeta } from "/app/apps/concierge/src/pages/not-shipped.spec.js?macro=true";
import { default as not_45shipped3tVt0LXiCaMeta } from "/app/apps/concierge/src/pages/not-shipped.vue?macro=true";
import { default as _91token_93nggH91JHeqMeta } from "/app/apps/concierge/src/pages/print/[token].vue?macro=true";
import { default as process_46specYX49P39FUFMeta } from "/app/apps/concierge/src/pages/process.spec.js?macro=true";
import { default as index_46specx6QOGZy4mBMeta } from "/app/apps/concierge/src/pages/process/index.spec.js?macro=true";
import { default as indexDjt1Hc7AUJMeta } from "/app/apps/concierge/src/pages/process/index.vue?macro=true";
import { default as processmYDWhIdThyMeta } from "/app/apps/concierge/src/pages/process.vue?macro=true";
import { default as resolution_46spec1xnoSwkbwmMeta } from "/app/apps/concierge/src/pages/resolution.spec.js?macro=true";
import { default as index_46spec4yeTcriTjyMeta } from "/app/apps/concierge/src/pages/resolution/index.spec.js?macro=true";
import { default as indexULyiQkaWFCMeta } from "/app/apps/concierge/src/pages/resolution/index.vue?macro=true";
import { default as review_46specN0kD768blVMeta } from "/app/apps/concierge/src/pages/resolution/review.spec.js?macro=true";
import { default as review3w0oaWGzkPMeta } from "/app/apps/concierge/src/pages/resolution/review.vue?macro=true";
import { default as resolutionIN9pafKanIMeta } from "/app/apps/concierge/src/pages/resolution.vue?macro=true";
import { default as return_46specxJbTydzXYkMeta } from "/app/apps/concierge/src/pages/return.spec.js?macro=true";
import { default as returne34PxO4rOMMeta } from "/app/apps/concierge/src/pages/return.vue?macro=true";
import { default as indexoGXiVJ5Z2SMeta } from "/app/apps/concierge/src/pages/sign/[claimId]/index.vue?macro=true";
import { default as start_46specU0cur5m9IMMeta } from "/app/apps/concierge/src/pages/start.spec.js?macro=true";
import { default as startv1reK3iRXPMeta } from "/app/apps/concierge/src/pages/start.vue?macro=true";
import { default as too_45late_46specWRkpk2a9OMMeta } from "/app/apps/concierge/src/pages/too-late.spec.js?macro=true";
import { default as too_45lateQlqdKhfNyrMeta } from "/app/apps/concierge/src/pages/too-late.vue?macro=true";
import { default as too_45soon_46specx4dErUfNnTMeta } from "/app/apps/concierge/src/pages/too-soon.spec.js?macro=true";
import { default as too_45soonafT68D1oYVMeta } from "/app/apps/concierge/src/pages/too-soon.vue?macro=true";
import { default as index_46specgiVwImzkRTMeta } from "/app/apps/concierge/src/pages/view/[token]/index.spec.js?macro=true";
import { default as indexIy8gc4KnuvMeta } from "/app/apps/concierge/src/pages/view/[token]/index.vue?macro=true";
import { default as reviewMFONAVXb9fMeta } from "/app/apps/concierge/src/pages/view/[token]/review.vue?macro=true";
export default [
  {
    name: "claim-received.spec___en",
    path: "/claim-received.spec",
    component: () => import("/app/apps/concierge/src/pages/claim-received.spec.js").then(m => m.default || m)
  },
  {
    name: "claim-received.spec___fr",
    path: "/fr/claim-received.spec",
    component: () => import("/app/apps/concierge/src/pages/claim-received.spec.js").then(m => m.default || m)
  },
  {
    name: "claim-received.spec___es",
    path: "/es/claim-received.spec",
    component: () => import("/app/apps/concierge/src/pages/claim-received.spec.js").then(m => m.default || m)
  },
  {
    name: "claim-received___en",
    path: "/claim-received",
    component: () => import("/app/apps/concierge/src/pages/claim-received.vue").then(m => m.default || m)
  },
  {
    name: "claim-received___fr",
    path: "/fr/claim-received",
    component: () => import("/app/apps/concierge/src/pages/claim-received.vue").then(m => m.default || m)
  },
  {
    name: "claim-received___es",
    path: "/es/claim-received",
    component: () => import("/app/apps/concierge/src/pages/claim-received.vue").then(m => m.default || m)
  },
  {
    name: contact_45infoE1QbxPQPlbMeta?.name,
    path: "/in-store/contact-info",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-contact-info-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-contact-info___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: contact_45infoE1QbxPQPlbMeta?.name,
    path: "/fr/in-store/contact-info",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-contact-info-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-contact-info___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: contact_45infoE1QbxPQPlbMeta?.name,
    path: "/es/in-store/contact-info",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-contact-info-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-contact-info___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/contact-info/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: date_45of_45purchasedkVr3rQxkvMeta?.name,
    path: "/in-store/date-of-purchase",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-date-of-purchase-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-date-of-purchase___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: date_45of_45purchasedkVr3rQxkvMeta?.name,
    path: "/fr/in-store/date-of-purchase",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-date-of-purchase-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-date-of-purchase___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: date_45of_45purchasedkVr3rQxkvMeta?.name,
    path: "/es/in-store/date-of-purchase",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-date-of-purchase-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-date-of-purchase___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/date-of-purchase/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productskftfBxuZWaMeta?.name,
    path: "/in-store/products",
    component: () => import("/app/apps/concierge/src/pages/in-store/products.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-products-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found-index.spec___en",
    path: "not-found/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found___en",
    path: "not-found",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productskftfBxuZWaMeta?.name,
    path: "/fr/in-store/products",
    component: () => import("/app/apps/concierge/src/pages/in-store/products.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-products-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found-index.spec___fr",
    path: "not-found/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found___fr",
    path: "not-found",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productskftfBxuZWaMeta?.name,
    path: "/es/in-store/products",
    component: () => import("/app/apps/concierge/src/pages/in-store/products.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-products-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found-index.spec___es",
    path: "not-found/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-products-not-found___es",
    path: "not-found",
    component: () => import("/app/apps/concierge/src/pages/in-store/products/not-found/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: receiptqXVH1zaSo3Meta?.name,
    path: "/in-store/receipt",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-receipt-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required-index.spec___en",
    path: "required/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required___en",
    path: "required",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload-index.spec___en",
    path: "upload/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload___en",
    path: "upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: receiptqXVH1zaSo3Meta?.name,
    path: "/fr/in-store/receipt",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-receipt-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required-index.spec___fr",
    path: "required/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required___fr",
    path: "required",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload-index.spec___fr",
    path: "upload/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload___fr",
    path: "upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: receiptqXVH1zaSo3Meta?.name,
    path: "/es/in-store/receipt",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-receipt-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required-index.spec___es",
    path: "required/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-required___es",
    path: "required",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/required/index.vue").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload-index.spec___es",
    path: "upload/index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-receipt-upload___es",
    path: "upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/receipt/upload/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionNnLUXJzuxwMeta?.name,
    path: "/in-store/resolution",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-resolution___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionNnLUXJzuxwMeta?.name,
    path: "/fr/in-store/resolution",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-resolution___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionNnLUXJzuxwMeta?.name,
    path: "/es/in-store/resolution",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-resolution___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/resolution/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: reviewSLW2cf9QkQMeta?.name,
    path: "/in-store/review",
    component: () => import("/app/apps/concierge/src/pages/in-store/review.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-review-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-review___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: reviewSLW2cf9QkQMeta?.name,
    path: "/fr/in-store/review",
    component: () => import("/app/apps/concierge/src/pages/in-store/review.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-review-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-review___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: reviewSLW2cf9QkQMeta?.name,
    path: "/es/in-store/review",
    component: () => import("/app/apps/concierge/src/pages/in-store/review.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-review-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-review___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: shipping_45addressV0NtiW5E3SMeta?.name,
    path: "/in-store/shipping-address",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-shipping-address-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-shipping-address___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: shipping_45addressV0NtiW5E3SMeta?.name,
    path: "/fr/in-store/shipping-address",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-shipping-address-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-shipping-address___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: shipping_45addressV0NtiW5E3SMeta?.name,
    path: "/es/in-store/shipping-address",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address.vue").then(m => m.default || m),
    children: [
  {
    name: "in-store-shipping-address-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.spec.js").then(m => m.default || m)
  },
  {
    name: "in-store-shipping-address___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/in-store/shipping-address/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "in-store-upload___en",
    path: "/in-store/upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/upload.vue").then(m => m.default || m)
  },
  {
    name: "in-store-upload___fr",
    path: "/fr/in-store/upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/upload.vue").then(m => m.default || m)
  },
  {
    name: "in-store-upload___es",
    path: "/es/in-store/upload",
    component: () => import("/app/apps/concierge/src/pages/in-store/upload.vue").then(m => m.default || m)
  },
  {
    name: "index.spec___en",
    path: "/index.spec",
    component: () => import("/app/apps/concierge/src/pages/index.spec.js").then(m => m.default || m)
  },
  {
    name: "index.spec___fr",
    path: "/fr/index.spec",
    component: () => import("/app/apps/concierge/src/pages/index.spec.js").then(m => m.default || m)
  },
  {
    name: "index.spec___es",
    path: "/es/index.spec",
    component: () => import("/app/apps/concierge/src/pages/index.spec.js").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/apps/concierge/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/apps/concierge/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/apps/concierge/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "issues.spec___en",
    path: "/issues.spec",
    component: () => import("/app/apps/concierge/src/pages/issues.spec.js").then(m => m.default || m)
  },
  {
    name: "issues.spec___fr",
    path: "/fr/issues.spec",
    component: () => import("/app/apps/concierge/src/pages/issues.spec.js").then(m => m.default || m)
  },
  {
    name: "issues.spec___es",
    path: "/es/issues.spec",
    component: () => import("/app/apps/concierge/src/pages/issues.spec.js").then(m => m.default || m)
  },
  {
    name: issuesePjfeQqLO9Meta?.name,
    path: "/issues",
    component: () => import("/app/apps/concierge/src/pages/issues.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/index.vue").then(m => m.default || m)
  },
  {
    name: "issues-items.spec___en",
    path: "items.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/items.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-items___en",
    path: "items",
    component: () => import("/app/apps/concierge/src/pages/issues/items.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment.spec___en",
    path: "shipment.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.spec.js").then(m => m.default || m)
  },
  {
    name: shipmentIdbapodMXWMeta?.name,
    path: "shipment",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-shipment-details.spec___en",
    path: "details.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment-details___en",
    path: "details",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: issuesePjfeQqLO9Meta?.name,
    path: "/fr/issues",
    component: () => import("/app/apps/concierge/src/pages/issues.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/index.vue").then(m => m.default || m)
  },
  {
    name: "issues-items.spec___fr",
    path: "items.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/items.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-items___fr",
    path: "items",
    component: () => import("/app/apps/concierge/src/pages/issues/items.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment.spec___fr",
    path: "shipment.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.spec.js").then(m => m.default || m)
  },
  {
    name: shipmentIdbapodMXWMeta?.name,
    path: "shipment",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-shipment-details.spec___fr",
    path: "details.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment-details___fr",
    path: "details",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: issuesePjfeQqLO9Meta?.name,
    path: "/es/issues",
    component: () => import("/app/apps/concierge/src/pages/issues.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/index.vue").then(m => m.default || m)
  },
  {
    name: "issues-items.spec___es",
    path: "items.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/items.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-items___es",
    path: "items",
    component: () => import("/app/apps/concierge/src/pages/issues/items.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment.spec___es",
    path: "shipment.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.spec.js").then(m => m.default || m)
  },
  {
    name: shipmentIdbapodMXWMeta?.name,
    path: "shipment",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment.vue").then(m => m.default || m),
    children: [
  {
    name: "issues-shipment-details.spec___es",
    path: "details.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment-details___es",
    path: "details",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/details.vue").then(m => m.default || m)
  },
  {
    name: "issues-shipment-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.spec.js").then(m => m.default || m)
  },
  {
    name: "issues-shipment___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/issues/shipment/index.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "multiple-shipments-index.spec___en",
    path: "/multiple-shipments/index.spec",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.spec.js").then(m => m.default || m)
  },
  {
    name: "multiple-shipments-index.spec___fr",
    path: "/fr/multiple-shipments/index.spec",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.spec.js").then(m => m.default || m)
  },
  {
    name: "multiple-shipments-index.spec___es",
    path: "/es/multiple-shipments/index.spec",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.spec.js").then(m => m.default || m)
  },
  {
    name: "multiple-shipments___en",
    path: "/multiple-shipments",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "multiple-shipments___fr",
    path: "/fr/multiple-shipments",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "multiple-shipments___es",
    path: "/es/multiple-shipments",
    component: () => import("/app/apps/concierge/src/pages/multiple-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "not-shipped.spec___en",
    path: "/not-shipped.spec",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.spec.js").then(m => m.default || m)
  },
  {
    name: "not-shipped.spec___fr",
    path: "/fr/not-shipped.spec",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.spec.js").then(m => m.default || m)
  },
  {
    name: "not-shipped.spec___es",
    path: "/es/not-shipped.spec",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.spec.js").then(m => m.default || m)
  },
  {
    name: "not-shipped___en",
    path: "/not-shipped",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.vue").then(m => m.default || m)
  },
  {
    name: "not-shipped___fr",
    path: "/fr/not-shipped",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.vue").then(m => m.default || m)
  },
  {
    name: "not-shipped___es",
    path: "/es/not-shipped",
    component: () => import("/app/apps/concierge/src/pages/not-shipped.vue").then(m => m.default || m)
  },
  {
    name: "print-token___en",
    path: "/print/:token()",
    component: () => import("/app/apps/concierge/src/pages/print/[token].vue").then(m => m.default || m)
  },
  {
    name: "print-token___fr",
    path: "/fr/print/:token()",
    component: () => import("/app/apps/concierge/src/pages/print/[token].vue").then(m => m.default || m)
  },
  {
    name: "print-token___es",
    path: "/es/print/:token()",
    component: () => import("/app/apps/concierge/src/pages/print/[token].vue").then(m => m.default || m)
  },
  {
    name: "process.spec___en",
    path: "/process.spec",
    component: () => import("/app/apps/concierge/src/pages/process.spec.js").then(m => m.default || m)
  },
  {
    name: "process.spec___fr",
    path: "/fr/process.spec",
    component: () => import("/app/apps/concierge/src/pages/process.spec.js").then(m => m.default || m)
  },
  {
    name: "process.spec___es",
    path: "/es/process.spec",
    component: () => import("/app/apps/concierge/src/pages/process.spec.js").then(m => m.default || m)
  },
  {
    name: processmYDWhIdThyMeta?.name,
    path: "/process",
    component: () => import("/app/apps/concierge/src/pages/process.vue").then(m => m.default || m),
    children: [
  {
    name: "process-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/process/index.spec.js").then(m => m.default || m)
  },
  {
    name: "process___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/process/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: processmYDWhIdThyMeta?.name,
    path: "/fr/process",
    component: () => import("/app/apps/concierge/src/pages/process.vue").then(m => m.default || m),
    children: [
  {
    name: "process-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/process/index.spec.js").then(m => m.default || m)
  },
  {
    name: "process___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/process/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: processmYDWhIdThyMeta?.name,
    path: "/es/process",
    component: () => import("/app/apps/concierge/src/pages/process.vue").then(m => m.default || m),
    children: [
  {
    name: "process-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/process/index.spec.js").then(m => m.default || m)
  },
  {
    name: "process___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/process/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "resolution.spec___en",
    path: "/resolution.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution.spec___fr",
    path: "/fr/resolution.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution.spec___es",
    path: "/es/resolution.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution.spec.js").then(m => m.default || m)
  },
  {
    name: resolutionIN9pafKanIMeta?.name,
    path: "/resolution",
    component: () => import("/app/apps/concierge/src/pages/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "resolution-index.spec___en",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution___en",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.vue").then(m => m.default || m)
  },
  {
    name: "resolution-review.spec___en",
    path: "review.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution-review___en",
    path: "review",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionIN9pafKanIMeta?.name,
    path: "/fr/resolution",
    component: () => import("/app/apps/concierge/src/pages/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "resolution-index.spec___fr",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution___fr",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.vue").then(m => m.default || m)
  },
  {
    name: "resolution-review.spec___fr",
    path: "review.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution-review___fr",
    path: "review",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.vue").then(m => m.default || m)
  }
]
  },
  {
    name: resolutionIN9pafKanIMeta?.name,
    path: "/es/resolution",
    component: () => import("/app/apps/concierge/src/pages/resolution.vue").then(m => m.default || m),
    children: [
  {
    name: "resolution-index.spec___es",
    path: "index.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution___es",
    path: "",
    component: () => import("/app/apps/concierge/src/pages/resolution/index.vue").then(m => m.default || m)
  },
  {
    name: "resolution-review.spec___es",
    path: "review.spec",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.spec.js").then(m => m.default || m)
  },
  {
    name: "resolution-review___es",
    path: "review",
    component: () => import("/app/apps/concierge/src/pages/resolution/review.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "return.spec___en",
    path: "/return.spec",
    component: () => import("/app/apps/concierge/src/pages/return.spec.js").then(m => m.default || m)
  },
  {
    name: "return.spec___fr",
    path: "/fr/return.spec",
    component: () => import("/app/apps/concierge/src/pages/return.spec.js").then(m => m.default || m)
  },
  {
    name: "return.spec___es",
    path: "/es/return.spec",
    component: () => import("/app/apps/concierge/src/pages/return.spec.js").then(m => m.default || m)
  },
  {
    name: "return___en",
    path: "/return",
    component: () => import("/app/apps/concierge/src/pages/return.vue").then(m => m.default || m)
  },
  {
    name: "return___fr",
    path: "/fr/return",
    component: () => import("/app/apps/concierge/src/pages/return.vue").then(m => m.default || m)
  },
  {
    name: "return___es",
    path: "/es/return",
    component: () => import("/app/apps/concierge/src/pages/return.vue").then(m => m.default || m)
  },
  {
    name: "sign-claimId___en",
    path: "/sign/:claimId()",
    component: () => import("/app/apps/concierge/src/pages/sign/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-claimId___fr",
    path: "/fr/sign/:claimId()",
    component: () => import("/app/apps/concierge/src/pages/sign/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-claimId___es",
    path: "/es/sign/:claimId()",
    component: () => import("/app/apps/concierge/src/pages/sign/[claimId]/index.vue").then(m => m.default || m)
  },
  {
    name: "start.spec___en",
    path: "/start.spec",
    component: () => import("/app/apps/concierge/src/pages/start.spec.js").then(m => m.default || m)
  },
  {
    name: "start.spec___fr",
    path: "/fr/start.spec",
    component: () => import("/app/apps/concierge/src/pages/start.spec.js").then(m => m.default || m)
  },
  {
    name: "start.spec___es",
    path: "/es/start.spec",
    component: () => import("/app/apps/concierge/src/pages/start.spec.js").then(m => m.default || m)
  },
  {
    name: "start___en",
    path: "/start",
    component: () => import("/app/apps/concierge/src/pages/start.vue").then(m => m.default || m)
  },
  {
    name: "start___fr",
    path: "/fr/start",
    component: () => import("/app/apps/concierge/src/pages/start.vue").then(m => m.default || m)
  },
  {
    name: "start___es",
    path: "/es/start",
    component: () => import("/app/apps/concierge/src/pages/start.vue").then(m => m.default || m)
  },
  {
    name: "too-late.spec___en",
    path: "/too-late.spec",
    component: () => import("/app/apps/concierge/src/pages/too-late.spec.js").then(m => m.default || m)
  },
  {
    name: "too-late.spec___fr",
    path: "/fr/too-late.spec",
    component: () => import("/app/apps/concierge/src/pages/too-late.spec.js").then(m => m.default || m)
  },
  {
    name: "too-late.spec___es",
    path: "/es/too-late.spec",
    component: () => import("/app/apps/concierge/src/pages/too-late.spec.js").then(m => m.default || m)
  },
  {
    name: "too-late___en",
    path: "/too-late",
    component: () => import("/app/apps/concierge/src/pages/too-late.vue").then(m => m.default || m)
  },
  {
    name: "too-late___fr",
    path: "/fr/too-late",
    component: () => import("/app/apps/concierge/src/pages/too-late.vue").then(m => m.default || m)
  },
  {
    name: "too-late___es",
    path: "/es/too-late",
    component: () => import("/app/apps/concierge/src/pages/too-late.vue").then(m => m.default || m)
  },
  {
    name: "too-soon.spec___en",
    path: "/too-soon.spec",
    component: () => import("/app/apps/concierge/src/pages/too-soon.spec.js").then(m => m.default || m)
  },
  {
    name: "too-soon.spec___fr",
    path: "/fr/too-soon.spec",
    component: () => import("/app/apps/concierge/src/pages/too-soon.spec.js").then(m => m.default || m)
  },
  {
    name: "too-soon.spec___es",
    path: "/es/too-soon.spec",
    component: () => import("/app/apps/concierge/src/pages/too-soon.spec.js").then(m => m.default || m)
  },
  {
    name: "too-soon___en",
    path: "/too-soon",
    component: () => import("/app/apps/concierge/src/pages/too-soon.vue").then(m => m.default || m)
  },
  {
    name: "too-soon___fr",
    path: "/fr/too-soon",
    component: () => import("/app/apps/concierge/src/pages/too-soon.vue").then(m => m.default || m)
  },
  {
    name: "too-soon___es",
    path: "/es/too-soon",
    component: () => import("/app/apps/concierge/src/pages/too-soon.vue").then(m => m.default || m)
  },
  {
    name: "view-token-index.spec___en",
    path: "/view/:token()/index.spec",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.spec.js").then(m => m.default || m)
  },
  {
    name: "view-token-index.spec___fr",
    path: "/fr/view/:token()/index.spec",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.spec.js").then(m => m.default || m)
  },
  {
    name: "view-token-index.spec___es",
    path: "/es/view/:token()/index.spec",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.spec.js").then(m => m.default || m)
  },
  {
    name: "view-token___en",
    path: "/view/:token()",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: "view-token___fr",
    path: "/fr/view/:token()",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: "view-token___es",
    path: "/es/view/:token()",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/index.vue").then(m => m.default || m)
  },
  {
    name: "view-token-review___en",
    path: "/view/:token()/review",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/review.vue").then(m => m.default || m)
  },
  {
    name: "view-token-review___fr",
    path: "/fr/view/:token()/review",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/review.vue").then(m => m.default || m)
  },
  {
    name: "view-token-review___es",
    path: "/es/view/:token()/review",
    component: () => import("/app/apps/concierge/src/pages/view/[token]/review.vue").then(m => m.default || m)
  }
]